import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';
import { useOpenBoloPanel } from '../../../bolo-panel/use-open-bolo-panel';
import { ContextMenuItem } from '../../../../context-menus/components/context-menu-item';

export function EditBoloItem({ boloId }: { boloId: number }) {
    const enabledFeatures = useEnabledFeatures();
    const openBoloPanel = useOpenBoloPanel();
    return (
        <ContextMenuItem
            contextMenuItemView={{
                isEnabled: true,
                isVisible: enabledFeatures.createBolos,
                label: 'Edit BOLO',
            }}
            onSelect={() => openBoloPanel({ boloId })}
        />
    );
}
